import { render, staticRenderFns } from "./SportCategories.vue?vue&type=template&id=70c10751&scoped=true&"
import script from "./SportCategories.vue?vue&type=script&lang=js&"
export * from "./SportCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c10751",
  null
  
)

export default component.exports